const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { hospital: hospitalApi } = require('@doctoroncallcom/api')
const {
  GET_HOSPITAL_LIST,
  GET_HOSPITAL,
  CREATE_HOSPITAL,
  UPDATE_HOSPITAL,
  UPDATE_HOSPITAL_STATUS,
  DELETE_HOSPITAL,
} = require('./constants')

const {
  getHospitalListSuccess,
  getHospitalListError,
  getHospitalSuccess,
  getHospitalError,
  createHospitalSuccess,
  createHospitalError,
  updateHospitalSuccess,
  updateHospitalError,
  updateHospitalStatusSuccess,
  updateHospitalStatusError,
  deleteHospitalSuccess,
  deleteHospitalError,
} = require('./actions')

const getHospitalsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_HOSPITAL_LIST),
  mergeMap(action => hospitalApi.getHospitalListApi(api, {
    type: action.payload.type,
    search: action.payload.search,
    take: action.payload.take,
    skip: action.payload.skip,
  })
    .then(response => getHospitalListSuccess(response.data))
    .catch(error => getHospitalListError(error))),
)

const getHospital = (action$, state$, { api }) => action$.pipe(
  ofType(GET_HOSPITAL),
  mergeMap(action => hospitalApi.getHospitalApi(api, action.payload.id)
    .then(response => getHospitalSuccess(response.data))
    .catch(error => getHospitalError(error))),
)

const createHospital = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_HOSPITAL),
  mergeMap(action => hospitalApi.createHospitalApi(api, action.payload.hospital)
    .then(response => createHospitalSuccess(response.data))
    .catch(error => createHospitalError(error))),
)

const updateHospital = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_HOSPITAL),
  mergeMap(action => hospitalApi.updateHospitalApi(api, action.payload.id, action.payload.hospital)
    .then(response => updateHospitalSuccess(response.data))
    .catch(error => updateHospitalError(error))),
)

const updateHospitalStatus = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_HOSPITAL_STATUS),
  mergeMap(action => hospitalApi.updateHospitalStatusApi(api, action.payload.id, action.payload.statusData)
    .then(response => updateHospitalStatusSuccess(response.data))
    .catch(error => updateHospitalStatusError(error))),
)

const deleteHospital = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_HOSPITAL),
  mergeMap(action => hospitalApi.deleteHospitalApi(api, action.payload.id)
    .then(response => deleteHospitalSuccess(response.data))
    .catch(error => deleteHospitalError(error))),
)

module.exports = {
  getHospitalsList,
  getHospital,
  createHospital,
  updateHospital,
  updateHospitalStatus,
  deleteHospital,
}
